// extracted by mini-css-extract-plugin
export var option = "_d5-0";
export var optionCard = "_d5-f";
export var optionContent = "_d5-g";
export var optionIcon = "_d5-i";
export var optionIconBox = "_d5-h";
export var optionLabel = "_d5-j";
export var optionPill = "_d5-m";
export var optionPillBadge = "_d5-p";
export var optionPillIcon = "_d5-n";
export var optionPillLabel = "_d5-o";
export var optionRadio = "_d5-k";
export var optionRadioInner = "_d5-l";
export var optionReveal = "_d5-2";
export var optionRevealDelay0 = "_d5-3";
export var optionRevealDelay1 = "_d5-4";
export var optionRevealDelay10 = "_d5-d";
export var optionRevealDelay11 = "_d5-e";
export var optionRevealDelay2 = "_d5-5";
export var optionRevealDelay3 = "_d5-6";
export var optionRevealDelay4 = "_d5-7";
export var optionRevealDelay5 = "_d5-8";
export var optionRevealDelay6 = "_d5-9";
export var optionRevealDelay7 = "_d5-a";
export var optionRevealDelay8 = "_d5-b";
export var optionRevealDelay9 = "_d5-c";
export var optionSelected = "_d5-1";